import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from '../themes/ThemeProvider';
import styles from './CompanySelection.module.css';
import { FooterLinks, Link } from './index';
const defaultLinks = [
    { href: '/privacidade', label: 'Termos de privacidade' },
    { href: '/politicas', label: 'Políticas de uso' },
    { href: 'https://www.dominiosistemas.com.br/suporte/', label: 'Suporte' },
];
export const CompanySelectionFooter = ({ links = defaultLinks, className = '', 'data-testid': dataTestId, }) => {
    const theme = useTheme();
    const whiteSeparator = (_jsx("span", { style: {
            width: 1,
            height: 8,
            background: theme.companySelectionFooterSeparator || '#ffffff',
            opacity: 0.3,
            display: 'inline-block',
            margin: '0 8px',
        } }));
    return (_jsx(FooterLinks, { className: `${styles.companySelectionFooterGlobal} ${className}`, separator: whiteSeparator, "data-testid": dataTestId, children: links.map((link, index) => (_jsx(Link, { href: link.href, className: styles.companySelectionFooterLink, variant: 'footer', "data-testid": dataTestId ? `${dataTestId}-link-${index}` : undefined, children: link.label }, index))) }));
};
